import "../app";

window.showHideReadMore = (e) => {
  e.preventDefault();

  const toggleFunc = (nodeList) => {
    if (nodeList) {
      Array.from(nodeList).forEach((element) => {
        const classList = element.classList;

        if (classList.contains("hide")) {
          classList.remove("hide");
        } else {
          classList.add("hide");
        }
      });
    } else {
      console.log("no node list found");
    }
  };

  const toggler = document.querySelector(".readmore-toggle");

  if (toggler) {
    const triggers = toggler.querySelectorAll(".readmore-trigger");

    toggleFunc(triggers);
  }

  const text = document.querySelector(".event-description-text");

  if (text) {
    const subtexts = text.querySelectorAll(".readmore-moretext");

    toggleFunc(subtexts);
  }
};
